import {
  CROSS_SELL_RECOMMENDATIONS_REQUEST,
  CROSS_SELL_RECOMMENDATIONS_SUCCESS,
  CROSS_SELL_RECOMMENDATIONS_FAILURE
} from '../actionTypes';

const defaultState = {
  data: {},
  loading: false,
  error: null
};

function crossSellRecommendations(state = defaultState, action) {
  switch (action.type) {
    case CROSS_SELL_RECOMMENDATIONS_REQUEST:
      return { data: [], loading: true, error: null };
    case CROSS_SELL_RECOMMENDATIONS_SUCCESS:
      return { data: action.payload, loading: false, error: null };
    case CROSS_SELL_RECOMMENDATIONS_FAILURE:
      return { data: [], loading: false, error: action.payload };
    default:
      return state;
  }
}

export default crossSellRecommendations;
